module.exports = __webpack_public_path__ + "img/granddad-two-kids-512x180-60.b693176d.jpg";